import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import FormGroup from '../decorators/FormGroup';
import InputText from '../controls/InputText';
var component = decorateControl(InputText, FormGroup);
var InputTextField = function InputTextField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({}, props, {
    component: component
  }));
};
export default InputTextField;